import api from '../../../utils/api'
import { useState, useEffect, useMemo } from "react"
import { FiInbox, FiCheck } from 'react-icons/fi'

import Input from "../../../shared/components/form/input"
import Button from "../../../shared/components/Button/Button"

function SelectSellersList({ selectedData, handleOnSelectItem, onFinishSelect }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const [users, setUsers] = useState([])
    const [search, setSearch] = useState("")
    const [load, setLoad] = useState(false)
    const [selectedItens, setSelectedItens] = useState(selectedData || [])

    useEffect(() => {
        api.get(`/client/getselectinfo`, {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => {
            if (response) {
                setUsers(response.data.users)
                setLoad(true)
            }
        })
    }, [token])

    const filter = useMemo(() => {
        return users.filter((item) => (item.name || '').toLowerCase().includes(search.toLowerCase()))
    }, [users, search])

    const isSelected = (item) => !!selectedItens.find((i) => i._id === item._id)

    const select = (item) => {
        const next = isSelected(item)
            ? selectedItens.filter((i) => i._id !== item._id)
            : [...selectedItens, item]
        setSelectedItens(next)
        handleOnSelectItem(next)
    }

    if (!load) {
        return <div className="pg-loading">Carregando usuários...</div>
    }

    return (
        <section className="pg-page">

            <div className="pg-sticky-top">
                <div className="pg-header">
                    <div className="pg-header-title">
                        <p className="pg-title">Selecionar Vendedores</p>
                        <span className="pg-title-accent" />
                    </div>
                    <div className="pg-header-row">
                        <div className="pg-header-actions">
                            <Button variant="finish" onClick={onFinishSelect}>Concluir</Button>
                            <span className="pg-count" style={{ marginLeft: '24px' }}>
                                {selectedItens.length} {selectedItens.length === 1 ? 'vendedor selecionado' : 'vendedores selecionados'}
                            </span>
                        </div>
                        <div className="pg-header-right">
                            <div className="pg-search">
                                <Input
                                    type="text"
                                    name="search"
                                    placeholder="Buscar usuário..."
                                    value={search}
                                    handleOnChange={(e) => setSearch(e.target.value)}
                                />
                            </div>
                            <span className="pg-count">
                                {filter.length} {filter.length === 1 ? 'usuário' : 'usuários'}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="pg-list">
                {filter.length > 0 ? (
                    filter.map((item) => (
                        <div
                            key={item._id}
                            className={`pg-item pg-item-selectable ${isSelected(item) ? 'pg-item-selected' : ''}`}
                            onClick={() => select(item)}
                        >
                            <div className="pg-item-main">
                                <div className="pg-item-header">
                                    <span className="pg-item-name">{item.name}</span>
                                </div>
                            </div>
                            <div className={`pg-item-checkbox ${isSelected(item) ? 'pg-item-checkbox-checked' : ''}`}>
                                <FiCheck size={14} />
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="pg-empty">
                        <FiInbox size={32} className="pg-empty-icon" />
                        <p className="pg-empty-title">Nenhum usuário encontrado</p>
                    </div>
                )}
            </div>

        </section>
    )
}

export default SelectSellersList
